import React from 'react';
import BankImportPage from './BankImportPage';

export default function CreditAgricolePage() {
  return (
    <BankImportPage
      title="Credit Agricole Import"
      description="Import Credit Agricole transactions using the 4-field format."
      fieldLabels={['Date', 'Libellé', 'Débit euros', 'Crédit euros']}
      listEndpoint="/api/credit-agricole"
      importEndpoint="/api/credit-agricole/import"
      bankId="CREDIT_AGRICOLE"
      emptyText="No Credit Agricole records found."
    />
  );
}
